<script setup>
import { ref, onMounted } from 'vue';

const isTyping = ref(false);
const currentLineIndex = ref(0);
const totalLines = 11;
const TYPING_INTERVAL = 300;  // Time between each line
const PAUSE_DELAY = 3000;     // Time to pause while text is visible
const FADE_DURATION = 500;    // Time for fade out animation

onMounted(() => {
    // Start the typing animation for the second editor
    startTypingAnimation();
});

const resetAnimation = () => {
    setTimeout(() => {
        currentLineIndex.value = 0;
        setTimeout(() => {
            startTypingAnimation();
        }, FADE_DURATION);
    }, PAUSE_DELAY);
};

const startTypingAnimation = () => {
    isTyping.value = true;
    const interval = setInterval(() => {
        if (currentLineIndex.value < totalLines) {
            currentLineIndex.value++;
        } else {
            clearInterval(interval);
            isTyping.value = false;
            resetAnimation();
        }
    }, TYPING_INTERVAL);
};
</script>

<style scoped>
.type-in {
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease-out;
}

.type-in.visible {
    opacity: 1;
    transform: translateY(0);
}

.type-in:not(.visible) {
    transition-duration: 0.5s;
}
</style>

<template>
    <!-- Chat Interface -->
    <div class="flex flex-col gap-4
        h-full sm:h-[400px] aspect-[3/4]
        mx-auto p-4 bg-gray-100 border border-slate-200 rounded-lg shadow-lg
    ">
        <div class="flex grow flex-col gap-4 [&_h2]:font-bold [&_p]:text-md [&_li]:text-md [&_li]:text-left
            bg-white py-1 px-4 rounded-lg shadow-sm">
                <p class="m-2 text-left type-in" :class="{ 'visible': currentLineIndex >= 1 }">These is what was said about the onboarding:</p>
                <!-- <h2 class="font-medium m-2 text-left type-in" :class="{ 'visible': currentLineIndex >= 1 }">Key Takeaways</h2> -->
                <ul class="space-y-1.3">
                    <li class="flex items-start type-in" :class="{ 'visible': currentLineIndex >= 2 }">
                        <span class="mr-2">•</span>
                        <span>The video is too long.</span>
                    </li>
                    <li class="flex items-start type-in" :class="{ 'visible': currentLineIndex >= 3 }">
                        <span class="mr-2">•</span>
                        <span>The user wants to skip the video and cannot.</span>
                    </li>
                    <li class="flex items-start type-in" :class="{ 'visible': currentLineIndex >= 4 }">
                        <span class="mr-2">•</span>
                        <span>The user didn't understand the value.</span>
                    </li>
                </ul>

                <!-- <h2 class="text-base font-medium mt-4 mb-2 text-left type-in" :class="{ 'visible': currentLineIndex >= 5 }">Conclusion</h2>
                <ul class="space-y-1.5">
                    <li class="flex items-start type-in" :class="{ 'visible': currentLineIndex >= 6 }">
                        <span class="mr-2">•</span>
                        <span>Aligning on goals will lead to a successful project.</span>
                    </li>
                    <li class="flex items-start type-in" :class="{ 'visible': currentLineIndex >= 7 }">
                        <span class="mr-2">•</span>
                        <span>Regular communication is key to staying on track.</span>
                    </li>
                </ul> -->
        </div>
        <div class="flex flex-row items-center h-10">
            <div 
                class="flex-1 border border-slate-300 rounded-lg p-2 h-full text-xs sm:text-sm bg-white shadow-sm text-nowrap overflow-y-auto flex items-center"
            >
                What was said about the onboarding?
            </div>
            <div class="ml-2 bg-blue-500 h-full text-white rounded-lg px-4 py-2">Ask</div>
        </div>
    </div>
</template>